<label class="form-control satisfaction-questionary">
  <span class="form-control__label"></span>
  <textarea class="text-field satisfaction-questionary__textarea"
            rows="7"
            [disabled]="disabled"
            [(ngModel)]="title">
  </textarea>
</label>
